/* eslint-disable */
export default {
  _Logo: 'Logo',
  _GoodJobPopup: 'GoodJobPopup',
}